export default {
  "die-set": [
    {
      id: 1,
      attachList: [
        { fileUrl: require("../../assets/images/supplier/die-set/凯威特.png") },
      ],
    },
    {
      id: 2,
      attachList: [
        { fileUrl: require("../../assets/images/supplier/die-set/华夏.png") },
      ],
    },
    {
      id: 3,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/die-set/宁兴特钢.png"),
        },
      ],
    },
    {
      id: 4,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/die-set/永为客模具.png"),
        },
      ],
    },
    {
      id: 5,
      attachList: [
        { fileUrl: require("../../assets/images/supplier/die-set/科佳.jpg") },
      ],
    },
    {
      id: 5,
      attachList: [
        { fileUrl: require("../../assets/images/supplier/die-set/龙祥.jpg") },
      ],
    },
  ],
  "hot-runner": [
    {
      id: 1,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/hot-runner/上海占瑞.jpg"),
        },
      ],
    },
    {
      id: 2,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/hot-runner/先锐模具.jpg"),
        },
      ],
    },
    {
      id: 3,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/hot-runner/柳道.png"),
        },
      ],
    },
    {
      id: 4,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/hot-runner/浙江恒道.jpg"),
        },
      ],
    },
    {
      id: 5,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/hot-runner/深圳麦士德福.jpg"),
        },
      ],
    },
    {
      id: 5,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/hot-runner/绍兴思德龙.jpg"),
        },
      ],
    },
    {
      id: 6,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/hot-runner/苏州好特斯.jpg"),
        },
      ],
    },
  ],
  "spare-parts": [
    {
      id: 1,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/spare-parts/匠心.png"),
        },
      ],
    },
    {
      id: 2,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/spare-parts/史陶比.png"),
        },
      ],
    },
    {
      id: 3,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/spare-parts/吉禾.png"),
        },
      ],
    },
    {
      id: 4,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/spare-parts/大石.png"),
        },
      ],
    },
    {
      id: 5,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/spare-parts/惠普斯.png"),
        },
      ],
    },
    {
      id: 5,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/spare-parts/百通.png"),
        },
      ],
    },
    {
      id: 6,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/spare-parts/益众源.png"),
        },
      ],
    },
    {
      id: 7,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/spare-parts/路德.png"),
        },
      ],
    },
    {
      id: 8,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/spare-parts/金贝特.jpg"),
        },
      ],
    },
    {
      id: 9,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/spare-parts/迪恩易.webp"),
        },
      ],
    },
  ],
  steel: [
    {
      id: 1,
      attachList: [
        { fileUrl: require("../../assets/images/supplier/steel/三和兴.jpg") },
      ],
    },
    {
      id: 2,
      attachList: [
        { fileUrl: require("../../assets/images/supplier/steel/上海凌力.jpg") },
      ],
    },
    {
      id: 3,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/steel/上海泰宝金属制品有限公司.jpg"),
        },
      ],
    },
    {
      id: 4,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/steel/东莞市友安金属.jpg"),
        },
      ],
    },
    {
      id: 5,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/steel/东莞市腾昌金属.jpg"),
        },
      ],
    },
    {
      id: 5,
      attachList: [
        { fileUrl: require("../../assets/images/supplier/steel/壹胜百.jpg") },
      ],
    },
    {
      id: 6,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/steel/宁波弘启金属.jpg"),
        },
      ],
    },
    {
      id: 7,
      attachList: [
        { fileUrl: require("../../assets/images/supplier/steel/广州骅星.jpg") },
      ],
    },
    {
      id: 8,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/steel/深圳市兆恒东北特钢.jpg"),
        },
      ],
    },
    {
      id: 9,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/steel/苏州日嘉兴.jpg"),
        },
      ],
    },
    {
      id: 10,
      attachList: [
        {
          fileUrl: require("../../assets/images/supplier/steel/重庆敏德兴.jpg"),
        },
      ],
    },
    {
      id: 11,
      attachList: [
        { fileUrl: require("../../assets/images/supplier/steel/青山万佳.jpg") },
      ],
    },
  ],
};
